import React from 'react';
import { Upload, Download } from '@carbon/icons-react';
import {
  RouteContainer,
  RouteGrid,
  LocationColumn,
  LocationTile,
  RoutePathContainer,
  TrucksPath,
  TruckItem,
  IconWrapper,
  EmptyState,
  TrucksLane,
  TrucksViewport
} from './TravelCard.Styles';
import { Tag, Tooltip } from '@carbon/react';
import Typography from '../Basics/Typography';
import TruckVector from '../../assets/icons/TruckVector.svg';
import Line from '../../assets/icons/Line_2.svg';
import { green50, gray60, green70, purple70 } from '@carbon/colors';
import { CustomTag } from '../../containers/Monitoring/Despacho/Despacho.styles';

const RouteRow = ({ route, textTitle }) => {
  // Guard clause - return early if route is not valid
  if (!route || !route.trucks || !Array.isArray(route.trucks)) {
    console.error('Invalid route prop:', route);
    return (
      <RouteContainer>
        <EmptyState>Error: Invalid route data</EmptyState>
      </RouteContainer>
    );
  }

  // Determine truck status and color based on current geofence
  const getTruckStatus = (truck) => {
    const currentGeofence = truck.geocerca_total_now;

    if (currentGeofence.includes('Plataforma')) {
      return { status: 'loading', color: '#ee5396', label: 'Patente' }; // Pink
    } else if (currentGeofence.includes('Velocidad') || currentGeofence.includes('Camino')) {
      return { status: 'moving', color: '#24a148', label: 'Patente' }; // Green
    } else if (currentGeofence.includes('Cola') || currentGeofence.includes('Cruce')) {
      return { status: 'waiting', color: '#0f62fe', label: 'Patente' }; // Blue
    } else {
      return { status: 'unknown', color: '#6f6f6f', label: 'Patente' }; // Gray
    }
  };

  // Determine tag color based on estado
  const getTagColor = (truck) => {
    const estado = (truck.estado || '').trim().toLowerCase();
    
    // If mantenimiento, use the truck's estadoColor
    if (estado === 'mantenimiento') {
      console.log(truck)
      return purple70;
    }
    
    // Otherwise, always green
    return green70;
  };
  const isIda = route.direccion === 'ida';
  const trucksCount = route.trucks.length;

  return (
    <RouteContainer>
      <RouteGrid>

        {/* Route Path */}
        <RoutePathContainer>
          <Typography className="cds--type-body-compact-01" color={gray60} margin="20px 0 0 20px">
            {textTitle}
          </Typography>

          {/* per-row horizontal scroller */}
          <TrucksViewport>
            <TrucksLane $truckscount={trucksCount}>
              {trucksCount > 0 ? (
                route.trucks.map((truck, index) => {
                  const truckStatus = getTruckStatus(truck);
                  const tagColor = getTagColor(truck);
                  return (
                    <TruckItem key={index}>
                      <Tooltip
                        align="bottom"
                        label={
                          <div style={{ lineHeight: '1.4em' }}>
                            <div><strong>Patente:</strong> {truck.patent}</div>
                            <div><strong>Ubicación:</strong> {truck.geocerca_total_now}</div>
                            <div><strong>Destino:</strong> {Math.round(truck.distancia, 2) ?? 'N/A'} km</div>
                          </div>
                        }
                      >
                        <CustomTag $color={tagColor}>{truck.patent}</CustomTag>
                      </Tooltip>
                    </TruckItem>
                  );
                })
              ) : (
                <EmptyState>No hay camiones en esta ruta</EmptyState>
              )}
            </TrucksLane>
          </TrucksViewport>

          <img src={Line} alt="linea" width="80%" style={{ marginBottom: "20px", marginLeft: "20px" }} />
        </RoutePathContainer>


        {/* Destination */}
        <LocationColumn>
          <LocationTile>
            <div className="location-title">
              {isIda ? route.destination : route.origin}
            </div>
          </LocationTile>
        </LocationColumn>
      </RouteGrid>
    </RouteContainer>
  );
};

export default RouteRow;